import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getProgramDetailsByProgramIds = (programIds: any[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getProgramDetailsByProgramIds,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      programIds: programIds,
    },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getProgramDetailsByProgramIds }
